import React from 'react';
import {NavLink, Link, Route, Routes} from 'react-router-dom';
import Products from './products';
const cx = require('classnames');

class ProductWrapper extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            routes: [
                {url: '/products/rate_profiles', name: 'Rate Profiles'},
    //            {url: '/products/calleridgroups', name: 'Caller ID Groups'}
            ]
        };
    }
    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <ul className="nav nav-tabs">
                            {
                                this.state.routes.map(function (row, i) {
                                    return (
                                        <li key={i} role="presentation" className={cx(row.url == this.props.pathname ? "active" : "")}>
                                            <NavLink exact={true} to={row.url}>{row.name}</NavLink>
                                        </li>)
                                }, this)
                            }
                        </ul>
                    </div>
                </div>
            </div>
        )
    }
};



export default class extends React.Component {
    render() {
        return (
            <div>
                <ProductWrapper pathname={this.props.location?.pathname}/>
                <Routes>
                    <Route index element={<Products />} />
                    {this.props.routes.map((route, i) => (
                        <Route 
                            key={i} 
                            path={route.path} 
                            element={<route.component routes={route.routes} childProps={this.props.childProps}/>} 
                        />
                    ))}
                </Routes>
            </div>
        )
    }
}